var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81377 4.09114C7.22167 4.49706 7.22156 5.15511 6.81377 5.56109L5.81365 6.55587C5.74708 6.62209 5.72383 6.72034 5.75366 6.80938C6.02537 7.62016 6.48319 8.35703 7.09075 8.96135C7.69831 9.56567 8.43914 10.021 9.25427 10.2913C9.34391 10.321 9.44265 10.2978 9.5096 10.2312L10.4443 9.30147C10.7268 9.02084 11.1764 8.99683 11.4882 9.24493L13.1076 10.5327C13.594 10.9197 13.6344 11.6416 13.1943 12.0798L12.172 13.0966C11.7957 13.4709 11.2369 13.5976 10.7348 13.4223L10.3577 13.2913C8.64635 12.6933 7.09225 11.7196 5.8096 10.4439L5.70494 10.3398C4.35354 8.99556 3.32326 7.36625 2.68973 5.57275L2.56793 5.22725C2.4152 4.79487 2.52455 4.31382 2.85033 3.98973L4.04216 2.80426C4.45031 2.39862 5.11189 2.39853 5.51999 2.80426L6.81377 4.09114Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ef5371b18682b0d5dc8fe8723bdec503.svg";
export { ForwardRef as ReactComponent };